<section class="data-table font-xs">
  @if (tableData.length > 0) {
    <div class="data-header-row">
      <span class="font-secondary-color font-xs data-header-item">{{
        "features.product-overview.productDocumentsParams.documentName"
          | translate
      }}</span>
      <span class="font-secondary-color font-xs data-header-item">{{
        "features.product-overview.productDocumentsParams.documentLanguage"
          | translate
      }}</span>
      <span class="font-secondary-color font-xs data-header-item">{{
        "features.product-overview.productDocumentsParams.documentFormat"
          | translate
      }}</span>
      <span class="font-secondary-color font-xs data-header-item">{{
        "features.product-overview.productDocumentsParams.documentSize"
          | translate
      }}</span>
      <span class="font-secondary-color font-xs data-header-item"></span>
    </div>
  }
  @for (tableData of tableData; track tableData.id) {
    <div
      class="data-row"
      [attr.data-download]="tableData.name"
      (click)="handleDownloadLinkClick(tableData.path, $event)"
      role="button"
      tabindex="0"
    >
      <div class="data-row-name">
        <div class="name-row">
          <span class="parameter font-primary-color">{{
            "features.product-overview.productDocumentsParams.documentName"
              | translate
          }}</span>
          <p class="filename-link font-primary-color">{{ tableData.name }}</p>
        </div>
      </div>
      <div class="language-row">
        <span class="parameter font-primary-color">{{
          "features.product-overview.productDocumentsParams.documentLanguage"
            | translate
        }}</span>
        <span class="font-primary-color">{{ tableData.language }}</span>
      </div>
      <div class="format-row">
        <span class="parameter font-primary-color">{{
          "features.product-overview.productDocumentsParams.documentFormat"
            | translate
        }}</span>
        <span class="font-primary-color">{{ tableData.format }}</span>
      </div>
      <div class="size-row">
        <span class="parameter font-primary-color">{{
          "features.product-overview.productDocumentsParams.documentSize"
            | translate
        }}</span>
        <span class="font-primary-color">{{ tableData.size }}</span>
      </div>
      <div class="cta-buttons">
        <a
          [href]="`${this.configService.piaAPIOrigin}/Document(${tableData.id})/$value`"
          class="button download-btn icon-only-button small"
          (click)="handleDownloadLinkClick(tableData.path, $event)"
          download="{{ tableData.name }}"
        >
          <claas-icon
            [id]="''"
            [iconId]="'659464'"
            [namespace]="'storybook'"
            [iconStyle]="'bold'"
            [size]="24"
            [alt]=""
            [iconName]="'favorites'"
            [removeDefaultColor]="true"
            [class]="'download-icon'"
          >
          </claas-icon>
        </a>
      </div>
    </div>
  }
</section>
